var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgarticle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2298,
    height: 1799,
    viewBox: "0 0 2298 1799",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1212 530.184L1512 350L1812 530.184V531.532L1512 711.715L1212 531.532V530.184Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 1101.18L417 921L717 1101.18V1102.53L417 1282.72L117 1102.53V1101.18Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1335 349.778L1522.13 461.164V649.497L1335 537.103V349.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1708.61 349.89L1521.48 461.159V649.295L1708.61 537.018V349.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1334.5 348.395L1521.63 236L1708.77 348.395V349.235L1521.63 461.63L1334.5 349.235V348.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240 920.778L427.133 1032.16V1220.5L240 1108.1V920.778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M613.61 920.89L426.482 1032.16V1220.3L613.61 1108.02V920.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M239.5 919.395L426.633 807L613.767 919.395V920.235L426.633 1032.63L239.5 920.235V919.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1296 571.426L1323.5 587.795V615.471L1296 598.954V571.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1350.9 571.443L1323.4 587.794V615.442L1350.9 598.942V571.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1296 571.517L1323.5 555L1351 571.517V571.64L1323.5 588.157L1296 571.64V571.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M472 1239.43L499.5 1255.79V1283.47L472 1266.95V1239.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M526.904 1239.44L499.404 1255.79V1283.44L526.904 1266.94V1239.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M472 1239.52L499.5 1223L527 1239.52V1239.64L499.5 1256.16L472 1239.64V1239.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1357 676.426L1384.5 692.795V720.471L1357 703.954V676.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1411.9 676.443L1384.4 692.794V720.441L1411.9 703.942V676.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1357 676.517L1384.5 660L1412 676.517V676.64L1384.5 693.157L1357 676.64V676.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M612 1156.43L639.5 1172.79V1200.47L612 1183.95V1156.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M666.904 1156.44L639.404 1172.79V1200.44L666.904 1183.94V1156.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M612 1156.52L639.5 1140L667 1156.52V1156.64L639.5 1173.16L612 1156.64V1156.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1709 574.426L1736.5 590.795V618.471L1709 601.954V574.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1763.9 574.443L1736.4 590.794V618.442L1763.9 601.942V574.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1709 574.517L1736.5 558L1764 574.517V574.64L1736.5 591.157L1709 574.64V574.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1688 774.426L1715.5 790.795V818.471L1688 801.954V774.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1742.9 774.443L1715.4 790.794V818.441L1742.9 801.942V774.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1688 774.517L1715.5 758L1743 774.517V774.64L1715.5 791.157L1688 774.64V774.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1192 651.946L1212 663.851V683.979L1192 671.967V651.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1231.93 651.958L1211.93 663.85V683.957L1231.93 671.958V651.958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1192 652.012L1212 640L1232 652.012V652.102L1212 664.114L1192 652.102V652.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1104.35,
    y1: 776.42,
    x2: 1421.43,
    y2: 589.646,
    stroke: "url(#paint2_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.354 1031.42L725.415 966",
    stroke: "url(#paint3_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.43 790.646L1587.5 916.073",
    stroke: "url(#paint4_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.354,
    y1: 1447.42,
    x2: 665.434,
    y2: 1260.65,
    stroke: "url(#paint5_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1740.43 648.646L1506.5 786.443",
    stroke: "url(#paint6_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 585V477",
    stroke: "url(#paint7_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1630 585V477",
    stroke: "url(#paint8_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1153.37,
    y1: 545.646,
    x2: 1323.97,
    y2: 646.138,
    stroke: "url(#paint9_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 640.369,
    y1: 915.646,
    x2: 724.809,
    y2: 965.385,
    stroke: "url(#paint10_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1421.94 590.507C1422.17 590.37 1422.33 590.157 1422.4 589.919C1422.75 589.765 1423 589.412 1423 589V481C1423 480.448 1422.55 480 1422 480C1421.45 480 1421 480.448 1421 481V588.745C1420.97 588.757 1420.95 588.771 1420.92 588.785L1269.93 678.139C1269.72 678.261 1269.58 678.446 1269.5 678.654C1269.11 678.604 1268.72 678.782 1268.51 679.138C1268.23 679.614 1268.39 680.227 1268.86 680.508L1363.49 736.249C1363.97 736.53 1364.58 736.371 1364.86 735.895C1365.14 735.419 1364.98 734.806 1364.51 734.526L1271.32 679.637L1421.94 590.507Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.08 736L1321 761.377",
    stroke: "url(#paint12_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1653.37,
    y1: 701.646,
    x2: 1910.13,
    y2: 852.892,
    stroke: "url(#paint13_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 641.369,
    y1: 1017.65,
    x2: 725.809,
    y2: 1067.38,
    stroke: "url(#paint14_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 512.369,
    y1: 1169.65,
    x2: 769.135,
    y2: 1320.89,
    stroke: "url(#paint15_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1631.37,
    y1: 585.646,
    x2: 1801.97,
    y2: 686.138,
    stroke: "url(#paint16_linear)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 1062,
    y: 200,
    width: 900,
    height: 661.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: -33,
    y: 771,
    width: 900,
    height: 661.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1812,
    y1: 382,
    x2: 1263.5,
    y2: 727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#441CE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB91D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 717,
    y1: 953,
    x2: 168.5,
    y2: 1298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A30F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 1104,
    y1: 777.998,
    x2: 1423,
    y2: 589.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 614.424,
    y1: 1032.76,
    x2: 787.542,
    y2: 931.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C76BCF",
    stopOpacity: 0.26
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 1588,
    y1: 916,
    x2: 1802,
    y2: 791.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 347.999,
    y1: 1449,
    x2: 666.999,
    y2: 1261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 1514,
    y1: 785.999,
    x2: 1742,
    y2: 648.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 1536,
    y1: 585,
    x2: 1536,
    y2: 477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 1536,
    y1: 585,
    x2: 1536,
    y2: 477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 1151.86,
    y1: 546.125,
    x2: 1324.33,
    y2: 647.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 650.001,
    y1: 921.998,
    x2: 771.854,
    y2: 996.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76BCF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C76BCF",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 1318.83,
    y1: 499.148,
    x2: 1276.45,
    y2: 529.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3749E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C76BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 1321.18,
    y1: 761.493,
    x2: 1364.4,
    y2: 736.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C76BCF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C76BCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 1941,
    y1: 868,
    x2: 1666.85,
    y2: 680.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 737.568,
    y1: 1071.24,
    x2: 643.25,
    y2: 1012.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 800,
    y1: 1336,
    x2: 525.847,
    y2: 1148.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 1750,
    y1: 673,
    x2: 1630.02,
    y2: 585.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2298,
    height: 1799,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgarticle);
export default __webpack_public_path__ + "static/media/bgarticle.e6a1879294ec9ad121778df5fa62779b.svg";
export { ForwardRef as ReactComponent };